import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timer, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface VersionInfo {
  version: string;
}

@Injectable({ providedIn: 'root' })
export class VersionService {

  private pollSub: Subscription;
  private readonly storageKey = 'app_version';
  private readonly url = '/assets/version.json';

  constructor(private http: HttpClient) { }

  startPolling(intervalMs: number = 60000): void {
    if (this.pollSub) {
      this.pollSub.unsubscribe();
    }

    this.pollSub = timer(0, intervalMs)
      .pipe(
        switchMap(() => this.http.get<VersionInfo>(`${this.url}?_ts=${Date.now()}`))
      )
      .subscribe({
        next: (info) => this.handleVersion(info?.version),
        error: () => { /* ignore transient errors */ }
      });
  }

  private handleVersion(remoteVersion: string): void {
    if (!remoteVersion) return;

    const localVersion = localStorage.getItem(this.storageKey);

    if (localVersion && localVersion !== remoteVersion) {
      // Version changed: force hard reload to fetch latest bundles
      localStorage.setItem(this.storageKey, remoteVersion);
      window.location.reload();
      return;
    }

    if (!localVersion) {
      localStorage.setItem(this.storageKey, remoteVersion);
    }
  }
}


